export default __webpack_public_path__ + "geomanist-light-webfont.ae07ef.woff";